// extracted by mini-css-extract-plugin
module.exports = {"label":"InvitationInput_label__2nYUc","styledInput":"InvitationInput_styledInput__2akih"};